
import { l, tryGetTokenOverride, selectLanguage } from "./localization.js";
import { general } from "./localizationAppToursGeneral.js";


export const tours = {
    general,

};
